import { Component } from 'react';
import Dropdown from 'core/dropdown';
import { ValueType } from 'modules/queryBuilder/legacyQueryBuilder/types';
import noop from 'utils/noop';
import { getValueTypeDropdownOptions } from './utils';

// type Props = {
//   className: string,
//   disabled: boolean,
//   /** Callback function when value of the dropdown changes. */
//   onChange: (e: {}, data: { valueType: string }) => void,
//   /** Show the contact property dropdown option. */
//   showContactProperty: boolean,
//   /** Show the trigger property dropdown option. */
//   showTriggerProperty: boolean,
//   /** Whether the dropdown should open upwards */
//   upward: boolean,
//   /** The value of the dropdown. */
//   value: string,
// };

export default class ValueTypeDropdown extends Component {
  static defaultProps = {
    disabled: false,
    onChange: noop,
    value: ValueType.Custom,
    upward: false,
    showContactProperty: false,
    showTriggerProperty: false,
  };

  /**
   * Callback when the value of the dropdown changes.
   * @param { Object } e: The change event.
   * @param { Object } dropdownProps: The updated dropdown props with the updated value.
   * @returns { void }
   */
  handleChange = (e, { value }) => {
    this.props.onChange(e, { ...this.props, value, valueType: value });
  };

  render() {
    const { className, disabled, value, upward, showContactProperty, showTriggerProperty } =
      this.props;
    const options = getValueTypeDropdownOptions({ showContactProperty, showTriggerProperty });

    return (
      <Dropdown
        data-test="collections-value-type-dropdown"
        className={className}
        disabled={disabled}
        onChange={this.handleChange}
        options={options}
        upward={upward}
        value={value}
      />
    );
  }
}
